import { ArrowRight } from "lucide-react";

const LandingHero = () => {
  const scrollToForm = () => {
    document.getElementById("growth-analysis")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative bg-hero-bg overflow-hidden">
      <div className="relative z-10 max-w-4xl mx-auto section-padding pt-28 pb-16 md:pt-36 md:pb-20">
        <div className="text-center">
          <div className="inline-block mb-6 reveal-up-delay-1">
            <span className="text-xs font-bold tracking-[0.2em] uppercase text-accent">
              For $1M+ Dental Practices Only
            </span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-[3.5rem] font-bold text-hero-foreground leading-[1.08] tracking-tight mb-6 reveal-up-delay-1">
            Get Your Practice Growth Score
          </h1>

          <p className="text-lg md:text-xl text-hero-foreground/60 max-w-2xl mx-auto mb-4 leading-relaxed reveal-up-delay-2">
            See exactly where your marketing stands — and what's holding your growth back.{" "}
            <span className="text-hero-foreground/80 font-medium">Instant results. No call required.</span>
          </p>

          <div className="grid sm:grid-cols-3 gap-4 max-w-2xl mx-auto mb-10 reveal-up-delay-3">
            {[
              "Instant score — no waiting",
              "Clear gaps across website, ads, SEO & patient flow",
              "90-day action plan built from real dental data",
            ].map((bullet) => (
              <div
                key={bullet}
                className="bg-hero-foreground/5 border border-hero-foreground/10 rounded-lg px-4 py-3 text-sm text-hero-foreground/80"
              >
                {bullet}
              </div>
            ))}
          </div>

          <button
            onClick={scrollToForm}
            className="inline-flex items-center justify-center gap-2 bg-accent text-accent-foreground px-8 py-4 rounded-lg text-base font-semibold hover:bg-accent/90 transition-all duration-200 active:scale-[0.97] shadow-lg shadow-accent/25 reveal-up-delay-3"
          >
            Start My Growth Analysis
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default LandingHero;
